import type { Locale } from "@zplanem/translations"
import { formatDistanceToNow } from "date-fns"
import { enUS, pl, uk } from "date-fns/locale"
import { useLocale } from "../../locale-context"

const dfLocaleMap = { en: enUS, pl, uk } as const

function formatAbsolute(iso: string, locale: Locale): string {
	const d = new Date(iso)
	const tag = locale === "uk" ? "uk-UA" : locale === "pl" ? "pl-PL" : "en-US"
	return d.toLocaleString(tag)
}

export function JournalTime({ iso }: { iso: string }) {
	const { locale } = useLocale()
	const d = new Date(iso)
	const relative = formatDistanceToNow(d, {
		addSuffix: true,
		locale: dfLocaleMap[locale],
	})
	const absolute = formatAbsolute(iso, locale)
	return (
		<time
			dateTime={iso}
			title={absolute}
			className="text-xs text-muted-foreground"
		>
			{relative}
		</time>
	)
}
